<template>
<v-container>
  <pre>
<h1>スマートホームサービス利用規約</h1>

本利用規約（以下「本規約」といいます。）には、株式会社リネジェス（以下「当社」といいます。）が提供するアプリケーション（以下「本アプリ」といいます。）及びこれに付随して提供するサービス（以下総称して「本サービス」といいます。）の提供条件及び当社とユーザーの皆様との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいたうえで、本規約に同意していただく必要があります。

第１条　適用

    本規約は、本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社の間の本サービスの利用に関わる一切の関係に適用されます。
    当社が当社ウェブサイト上で掲載する本サービス利用に関するルールは本規約の一部を構成します。
    本規約の内容と、前項のルールその他の本規約外における本サービスの説明等とが異なる場合は、本規約の規定が優先して適用されます。

第２条　定義

本規約において使用する以下の用語は各々以下に定める意味を有するものとします。

（1）「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）を意味します。

（2）「当社ウェブサイト」とは、そのドメインが「renegess.co.jp」あるいは「linqa.jp」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。

（3）「利用契約」とは、本規約及び当社とユーザーの間で締結する、本サービスの利用契約を意味します。

（4）「本製品」とは、本サービスの利用のために当社が提供するハードウェアを意味します。

（5）「接続機器」とは、本サービスの利用のために本製品とインターネットにより接続される家庭用電気機器を意味します。

（6）「提携事業者等」とは、当社との提携の下でユーザーに本製品及び本製品に付随するソフトウェア等を提供する事業者を意味します。

第３条　ハードウェアその他の設備

    本製品その他の本サービスの提供を受けるために必要なハードウェア、スマートフォンその他の機器、接続機器、通信手段、ソフトウェア等は、ユーザーが自らの責任と費用において、適切に設置及び操作しなければなりません。同操作等について当社は一切の責任を負いません。
    ユーザーは、ユーザーのインターネット接続環境等によって、本サービスを利用又は閲覧するために通信費等が別途必要となることに同意し、同通信費等の一切を負担するものとします。
    ユーザーは、ユーザーのインターネット接続環境等によって、本サービスの一部を閲覧又は利用できない可能性があることを予め了承するものとします。

 ユーザーは、本サービスの利用にあたり、本製品のゲートウェイを設置先の玄関やリビングなどに配置し、インターネット回線と接続されていることおよびスマートフォンアプリの利用が可能であることの確認が必要です。ユーザーは、設置先の建物の権利者等に本製品が設置されることについて、あらかじめ承諾を得る必要があります。


第４条　本サービスにおける禁止事項

    ユーザーは、本サービス又は本製品の利用にあたり、以下の各号のいずれかに該当する行為、又はそのおそれのある行為をしてはなりません。

（1）当社のネットワーク又はシステムに不正にアクセスし、又は　不正なアクセスを試みる行為

（2）有害なコンピュータプログラム等を送信もしくは掲載し、又は第三者が受信可能な状態におく行為

（3）当社、エンドユーザー又はその他第三者に対する詐欺又は脅迫行為

（4）本人の同意を得ることなく又は偽計により第三者の個人情報を収集する行為

（5）ストーカー行為等の規制等に関する法律に違反する行為

（6）反社会的勢力等への利益供与

（7）当社もしくは第三者の財産、知的財産権、プライバシーもしくは肖像権を侵害する行為、又は侵害するおそれのある行為

（8）本サービスのネットワーク又はシステム等に過度な負荷をかける行為

（9）本サービスもしくは本製品のリバースエンジニアリング等の解析行為又は本製品を改造する行為

（10）当社又は第三者になりすまして本サービスを利用する行為

（11）本サービスの運営を妨害するおそれのある行為

（12）本サービスの終了後に本サービス及び本製品を利用する行為

（13）本サービスに係るユーザーID及びパスワード等の認証情報の管理を怠り、又は当社の承諾なく第三者にこれを開示、貸与、共有、漏えい等をする行為

（14）当社の信用を毀損し又は当社の財産を侵害する行為

（15）本製品あるいは本サービスを日本国外で使用する行為

（16）前各号の他、法令もしくは公序良俗に違反する行為

（17）その他、当社が不適切と判断する行為

    当社は、本サービスにおけるユーザーの行為が前項各号のいずれかに該当し、又は該当するおそれがあると判断した場合には、ユーザーに事前に通知することなく、本サービスの利用停止等の措置を採ることができるものとします。当社は、本項に基づき当社が行った措置によってユーザーに生じた損害について一切の責任を負いません。

ユーザーは、本条第1項各号のいずれかに該当する行為により当社に損害を与えたときは、当社が被った全ての損害を賠償するものとします。

第５条　本サービスの停止等

    当社は、以下のいずれかに該当する場合には、事前の通知なく本サービスの利用の全部又は一部を停止又は中断することができるものとします。

（1）本サービスに係るコンピューター・システムの点検、保守又は修理作業を定期的又は緊急に行う場合

（2）天災地変、停電、戦争、暴動、騒乱、労働争議、電気通信事業者等による電気通信サービス停止、プラットフォーム提供者によるサービス停止その他の不可抗力により本サービスの提供ができなくなった場合

（3）その他、当社が停止又は中断を必要と判断した場合

    当社は、当社の都合により、本サービスの提供を終了することができます。この場合、当社はユーザーに事前に通知するものとします。
    当社は、本条に基づき当社が行った措置によってユーザーに生じた損害について一切の責任を負いません。

第６条　権利の帰属

当社ウェブサイト及び本サービスに関する知的財産権その他の権利は全て当社、当社にライセンスを許諾している者、提携事業者等又は当社が業務提携するその他の事業者に帰属しており、本規約に基づく本サービスの利用許諾は、当社ウェブサイト又は本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権のユーザーへの移転又はユーザー以外の第三者への利用許諾を意味するものではありません。

第７条　保証の否認及び免責

    当社は、本サービス及び本製品がユーザーの特定の目的に適合すること、期待する機能・商品価値・正確性・有用性を有すること、ならびにユーザーによる本サービス及び本製品の利用がユーザーに適用のある法令又は業界団体の内部規則等に適合すること及び不具合が生じないことについて、何ら保証するものではありません。
    当社は、本サービスの提供の中断、停止、終了、利用不能又は変更、ユーザーに対する本サービス利用停止措置、本製品の不具合、接続機器の故障又は動作不良その他本サービスに関してユーザーが被った損害について、賠償する責任を一切負わないものとします。
    前項の損害につき何らかの理由により当社が責任を負う場合であっても、当社は、付随的損害、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については賠償する責任を負わず、かつ、ユーザーが利用する本製品の価格相当額を限度額としてのみ損害賠償責任を負うものとします。
    本サービス又は当社ウェブサイトに関連してユーザーと他のユーザー、ISP等又は第三者との間において生じた取引、連絡、紛争等については、当社は一切責任を負いません。

第８条　損害賠償

ユーザーは、本規約、各ガイドライン若しくは法令の定めに違反したことにより又は故意若しくは過失により、当社又は提携事業者等を含む第三者に損害を及ぼした場合、当該損害を賠償する責任を負い、いかなる場合も当社及び提携事業者等を含む第三者を免責するものとします。

第９条　秘密保持等

ユーザーは、本サービスに関連して当社がユーザーに対して秘密に取り扱うことを求めて開示した非公知の情報について、当社の事前の書面による承諾がある場合を除き、秘密に取り扱うものとします。

第１０条　利用者情報の取扱い

当社によるユーザーの利用者情報の取扱いについては、別途当社プライバシーポリシー（http://rengess.co.jp/privacypolicy/）の定めによるものとし、ユーザーはこのプライバシーポリシーに従って当社がユーザーの利用者情報を取り扱うことについて同意するものとします。

第１１条　本規約の変更

当社は、本規約を変更できるものとします。当社は、本規約を変更した場合には、ユーザーに当該変更内容を通知するものとし、当該変更内容の通知後、ユーザーが本サービスを利用した場合には、ユーザーは、本規約の変更に同意したものとみなします。

第１２条 　連絡/通知

本サービスに関する問い合わせその他ユーザーから当社に対する連絡又は通知、及び本規約の変更に関する通知その他当社からユーザーに対する連絡又は通知は、当社の定める方法で行うものとします。

第１３条 　利用契約上の地位の譲渡等

    ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
    当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務ならびにユーザーの情報等を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、狭義の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。

第１４条 　分離可能性

本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定又は一部が無効もしくは執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及びユーザーは、 当該無効もしくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効もしくは執行不能な条項又は部分の趣旨ならびに法律的及び経済的に同等の効果を確保できるように努めるものとします。

第１５条 　準拠法及び管轄裁判所

本規約及び利用契約の準拠法は日本法とし、本規約又は利用契約に起因し又は関連する一切の紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
  </pre>
</v-container>
</template>

<script>
export default {
  name: 'Privacy'
}
</script>

<style scoped>
pre {
  white-space: pre-wrap;
  /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;
  /* Mozilla, since 1999 */
  white-space: -pre-wrap;
  /* Opera 4-6 */
  white-space: -o-pre-wrap;
  /* Opera 7 */
  word-wrap: break-word;
  /* Internet Explorer 5.5+ */
  line-height: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Terms.vue